var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "popper",
    {
      ref: "pop",
      attrs: {
        trigger: "clickToToggle",
        options: {
          arrow: true,
          placement: this.placement || "bottom",
          xmodifiers: { offset: { offset: "0,10px" } },
        },
      },
    },
    [
      !_vm.inactive
        ? _c("div", { staticClass: "p-5 popper" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.go()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.text || "Sûr ?"))]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default", null, { slot: "reference" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }